import React, { useContext, useState } from "react";
import CarTypeForm from "../Forms/CarTypeForm";
import CustomTabs from "../../../CommonElements/CommonTabs/CustomTabs";
function CarTypeFlow() {
  

  const tabs = [

    { label: "Car Type", content: <CarTypeForm /> },
    
  ];

  return (
  <div>
    <CustomTabs tabs={tabs} />
  </div>
);
}

export default CarTypeFlow;
